import { render, staticRenderFns } from "./ReportsTable.vue?vue&type=template&id=60937afd&scoped=true&"
import script from "./ReportsTable.vue?vue&type=script&lang=js&"
export * from "./ReportsTable.vue?vue&type=script&lang=js&"
import style0 from "./ReportsTable.vue?vue&type=style&index=0&id=60937afd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60937afd",
  null
  
)

export default component.exports